import { EMPTY_STRING } from '../../../constants/common'
import { ASC_ORDER_SYMBOL, DESC_ORDER_SYMBOL } from '../../../constants/sort'
import { getDescSortParam } from '../../../utils/sort'

import { QA_NAME_SORTING_BUTTON } from './TableHeaderRowCellSortingButton.constants'

import SortingIcon from '../../../icons/sorting.svg'
import SortingDownIcon from '../../../icons/sorting-down.svg'
import SortingUpIcon from '../../../icons/sorting-up.svg'

export function getSortingDirection(ordering, orderingField) {
  if (ordering.includes(orderingField)) {
    return {
      Icon: SortingUpIcon,
      sortDirection: ASC_ORDER_SYMBOL,
    }
  } else if (ordering.includes(getDescSortParam(orderingField))) {
    return {
      Icon: SortingDownIcon,
      sortDirection: DESC_ORDER_SYMBOL,
    }
  }

  return {
    Icon: SortingIcon,
    sortDirection: EMPTY_STRING,
  }
}

export function getButtonQaName(field) {
  return `${field}_${QA_NAME_SORTING_BUTTON}`
}
